import { createTheme, ThemeProvider } from '@offline-mui/material/styles'
import type { ReactNode } from 'react'
import './accounting.css'

// Same palette as the standalone Leo accounting tool.
const theme = createTheme({
  palette: {
    primary: { main: '#0b6e6a' },
    secondary: { main: '#e76f51' },
    info: { main: '#1d4e89' },
    warning: { main: '#e9b44c', contrastText: '#1b2430' },
    success: { main: '#2a9d8f' },
    background: { default: '#eef3f8', paper: '#ffffff' },
    text: { primary: '#1b2430' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Avenir Next", "Segoe UI", sans-serif',
    h1: { fontSize: '2rem', fontWeight: 700, letterSpacing: '-0.03em' },
  },
})

export function AccountingProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <div className="accounting-root">{children}</div>
    </ThemeProvider>
  )
}
